import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaTimesCircle, } from "react-icons/fa";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import { Container, Row, Col } from "react-bootstrap";
import len from '../../assets/svg/lentra.svg'
import profile from '../../assets/svg/profile.svg'
import production from '../../assets/svg/production.svg'
import check_failed from '../../assets/svg/druken.svg'
import temp from '../../assets/svg/temp.svg'
import add from '../../assets/svg/add.svg'
import nandhu from '../../assets/svg/nandhu.svg'
import { ReactComponent as ItemNameIcon } from "../../assets/svg/itemname.svg";
import { ReactComponent as QuantityIcon } from "../../assets/svg/Quantity.svg";
import { ReactComponent as DescriptionIcon } from "../../assets/svg/Description.svg";
import { ReactComponent as MoreIcon } from "../../assets/svg/more.svg";
import "./gate-out-modal.css";
import AddItemModal from "./add-item-modal";
import userTemp from '../../assets/png/customer-icon.png'
import { getFailedCheckList } from "../visitor/visitor-api";

const GateOutModal = ({ moduleName, visitorDetails, onProceed, onCancel, }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [alertItemIndex, setAlertItemIndex] = useState(null);
  const [showAddItemModal, setAddItemModal] = useState(false);
  const [itemData, setItemData] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const getSafeValue = (value) => {
    return value === '' || value === null || value === undefined ? '-' : value;
  };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "1000px",
      height: "500px",
      overflowY: "auto",
    },
  };


  const [loading, setLoading] = useState(false);
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [description, setDescription] = useState("");
  useEffect(() => {
    getFailedCheck();
  }, [visitorDetails]);



  const alertRef = useRef(null);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertItemIndex(null); // Close the alert
    }
  };
  const onSaveItem = (itemData) => {
    setAddItemModal(false);
    const tempItem = [...itemList];
    if (itemData.index === null) {
      tempItem.push(itemData.item)
    } else {
      tempItem[itemData.index] = itemData.item;
    }
    setItemList(tempItem)
  }
  const getFailedCheck = async () => {
    try {
      const response = await getFailedCheckList(visitorDetails.id, moduleName);
      if (response.success === true) {
        setCheckList(response.suggestionlist)
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  return (<div style={modalStyle.overlay}>
    {showAddItemModal && <AddItemModal itemData={itemData} onSave={onSaveItem} onCancel={() => { setAddItemModal(false); setItemData(null) }} />}
    <div style={modalStyle.modal}>

      <div >
        <div className="modal-header style-justify-between"
        >
          <div className="modal-title"
          >
            Gate out
          </div>
          <img
            src={ModalCloseIcon}
            alt="Close"
            onClick={onCancel}
            style={{ cursor: "pointer", width: "30px", height: "30px", borderRadius: "50%" }}
          />

        </div>

        <div style={{ display: "flex", gap: "8px" }}>
          {/* Left Section */}
          <div
            style={{
              width: "40%",
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "15px",

            }}
          >
            {/* Profile */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <img
                src={visitorDetails.profilephoto !== "" && visitorDetails.profilephoto ? visitorDetails.profilephoto : userTemp}
                alt="Profile"
                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
              />
              <div>
                <div className="visitor-name">
                  {getSafeValue(visitorDetails.visitor_name)} {visitorDetails.driver_name ?? ''}
                </div>
                {moduleName === "Visitor" && (<div><img src={len} alt="" /> <span className="org-title">{getSafeValue(visitorDetails.organization)}</span>
                </div>)}
                {moduleName === "Vehicle" && (<div style={{ display: "flex", alignItems: "center", }}>
                  <div className="field-title pt-1">{getSafeValue(visitorDetails.vehicle_number)}</div> <span className="dot-span mx-2"></span> <div className="vehicle-type-card px-2 pt-1">{visitorDetails.vehicle_type}</div>
                </div>)}
              </div>
            </div>

            {/* Info Badges */}
            <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>
              <div className="in-time-card px-2 py-1"                            >
                <span className="in-time-title">In time</span>
                <div className="font-13-600">
                  {getSafeValue(visitorDetails.in_time)}
                </div>
              </div>
              <div
                className="in-time-card  px-2 py-1"
              >
                <span className="in-time-title">Purpose of visit</span>
                <div className="font-13-600">
                  {getSafeValue(visitorDetails.visit_purpose)}
                </div>
              </div>
            </div>

            {/* Details */}
            <div className="detail-card mt-2"

            >
              <div className="details font-15-700 ">Details</div>
              <div className="px-2 pt-2">
                <div className="style-justify-start" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Meeting type </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D"> {getSafeValue(visitorDetails.meeting_type)} </div>
                </div>
                <div className="style-justify-start  mt-1" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Email </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D">{getSafeValue(visitorDetails.email)}</div>
                </div>
                <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Mobile number </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D">{getSafeValue(visitorDetails.mobile_number)}</div>
                </div>
                <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Location </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D">{getSafeValue(visitorDetails.location)}</div>
                </div>
                <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Entry Gate </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D">{getSafeValue(visitorDetails.gate)}</div>
                </div>
                {moduleName === "Visitor" && (<div className="mt-3 mb-2"
                  style={{

                    backgroundColor: "#F9F9F9",
                    padding: "20px",
                    borderRadius: "12px",

                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    fontFamily: "Arial, sans-serif",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div style={{ position: 'relative' }}>
                    <div className="w-100 meeting-person-dotted"> </div>
                    <span
                      style={{
                        position: "absolute",
                        top: '-12px',
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#ffffff",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        color: "#5f6368",
                        fontWeight: "500",
                      }}
                    >
                      Meeting person
                    </span>
                  </div>
                  <div className="style-justify-start mt-3">
                    <img
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        marginRight: "12px",
                        border: "1px solid #e0e0e0",
                      }}
                      src={visitorDetails.meeting_person_profile ?? userTemp}
                      alt="Profile"
                    />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#202124",
                          marginBottom: "2px",
                        }}
                      >
                        {getSafeValue(visitorDetails.meeting_person) ?? ''} {visitorDetails.meeting_person_name ?? ''}
                      </span>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          color: "#137333",
                          fontWeight: "500",
                        }}
                      >
                        <img
                          style={{ width: "16px", height: "16px", marginRight: "6px" }}
                          src={production}
                          alt="Briefcase Icon"
                        />
                        {getSafeValue(visitorDetails.department)}
                      </div>
                    </div>
                  </div>
                </div>)}
              </div>
            </div>

          </div>


          {/* Right Section */}
          <div
            style={{
              width: "60%",
              background: "#fff",

              padding: "12px",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Checklist */}
            <div style={{ background: "#F6F7F8", borderRadius: "24px", padding: "12px", }}>
              <h4 style={{ fontSize: "14px", fontWeight: "bold" }}>Check list</h4>
              <div style={{ display: "flex", gap: "10px", }}>
                {checkList?.map((check, index) => { return <span className="font-13-500-172B4D" style={{ backgroundColor: "#ffffff", padding: "4px 12px", borderRadius: "12px" }}> <FaTimesCircle style={{ color: check.status === "false" ? 'red' : "green" }} />  {/* <img src={check_failed} alt=""/> */} {check.checkname ?? ''}{' '}{check.creteria === 'Range' ? check.value : ''}</span> })}

              </div>
            </div>
            {/* Carrying Items */}
            <div className="font-15-700 mt-1 mb-1">Carrying Items</div>

            <div className="item-list-header" style={{ flex: '12', marginRight: '16px' }}>

              <span className="item-list-header-txt style-justify-start" style={{ flex: '4' }}><ItemNameIcon style={{ marginRight: '8px' }} />Item Name</span>
              <span className="item-list-header-txt style-justify-start" style={{ flex: '3' }}><QuantityIcon style={{ marginRight: '8px' }} />Quantity</span>
              <span className="item-list-header-txt style-justify-start" style={{ flex: '5' }}><DescriptionIcon style={{ marginRight: '8px' }} />Description</span>

            </div>
            <div style={{ height: '180px', overflowY: 'scroll' }}>
              {visitorDetails?.itemList?.map((item, index) => (
                <div key={'item-list' + index}>

                  <               div className="item-list-row" style={{ flex: '12', }}>

                    <span className="item-list-row-txt" style={{ flex: '4' }}>{item.item_name}</span>
                    <span className="item-list-row-txt" style={{ flex: '3' }}>{item.quantity}</span>
                    <div className="item-list-row-txt" style={{ flex: '5', position: "relative" }} >
                      <span >{item.description}</span>

                    </div>

                  </div>
                </div>))}
              {itemList?.map((item, index) => (
                <div key={'item-list' + index}>

                  <               div className="item-list-row" style={{ flex: '12', }}>

                    <span className="item-list-row-txt" style={{ flex: '4' }}>{item.item_name}</span>
                    <span className="item-list-row-txt" style={{ flex: '3' }}>{item.quantity}</span>
                    <div className="item-list-row-txt" style={{ flex: '5', position: "relative" }} >
                      <span >{item.description}</span>
                      <div style={{ position: "absolute", position: 'absolute', top: "5px", right: "5px", }}>
                        <div style={{ position: "relative" }}>
                          <MoreIcon style={{ cursor: 'pointer' }} onClick={() => { setAlertItemIndex(index === alertItemIndex ? null : index); }} />
                          {alertItemIndex === index && (
                            <div ref={alertRef} style={{
                              position: "absolute",
                              top: "40px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              backgroundColor: "#ffffff",
                              color: "#1E1E1E",
                              padding: "16px",
                              borderRadius: "16px",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                              zIndex: 1, alignItems: 'end',
                            }}>
                              <div onClick={() => { setItemData({ "item": item, "index": index }); setAddItemModal(true); setAlertItemIndex(null) }} style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                                Edit
                              </div>
                              <div onClick={() => {
                                const tempItems = [...itemList];
                                tempItems.splice(index, 1);
                                setItemList(tempItems)
                                setAlertItemIndex(null)
                              }} style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                                Delete
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>))}
            </div>


            {/* Buttons */}
            <button className="mt-2"
              style={{
                background: "none",
                color: "#166534",
                border: "1px solid #E5E5E5",
                padding: "6px 12px",
                borderRadius: "5px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={() => {
                setAlertItemIndex(null)
                setAddItemModal(true);
              }}
            >
              <img src={add} alt="" /> <span className="font-13-700-2C8C53">Add item</span>
            </button>

            <button
              style={{
                width: "100%",
                marginTop: "10px",
                padding: "8px",
                background: "#2C8C53",
                color: "white",
                fontWeight: "bold",
                borderRadius: "30px",
                border: "none",
                cursor: "pointer",
              }}
              className="font-14-700-FFFFFF"
              onClick={() => { onProceed(itemList) }}
            >
              Proceed to gate out
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>);

}

export default GateOutModal;